<small
  *ngIf="formCtrl.errors?.min && (formCtrl.dirty || formCtrl.touched)"
  class="p-invalid"
>
  {{ errorMsg }}
</small>
